var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoInsecure24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.999,
    height: 16,
    viewBox: "0 0 11.999 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_insecure24x24",
    transform: "translate(-91.455 .001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(91.455 -.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M102.187,6.856h-.176V3.9a4.61,4.61,0,0,0-9.112,0V6.856h-.176a1.19,1.19,0,0,0-1.268,1.086v5.9A2.356,2.356,0,0,0,93.964,16h6.981a2.356,2.356,0,0,0,2.509-2.15v-5.9a1.19,1.19,0,0,0-1.267-1.086Zm-3.2,5.2a.422.422,0,0,1,0,.659.613.613,0,0,1-.772,0l-.762-.653-.738.632a.613.613,0,0,1-.772,0,.422.422,0,0,1,0-.659l.738-.632-.78-.668a.423.423,0,0,1,0-.659.613.613,0,0,1,.772,0l.78.668.8-.689a.613.613,0,0,1,.772,0,.423.423,0,0,1,0,.659l-.8.689Zm.3-5.2H95.619V3.887a1.858,1.858,0,0,1,3.672,0V6.856Z",
    transform: "translate(-91.455 .001)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoInsecure24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_insecure24x24.645e60603ee9a49f90528e92e8a41096.svg";